/* AllySabers header: dropdowns, mobile menu and header measurements.
   Product variants, gallery and cart remain owned by Impact. */
(() => {
  const selector = '.ally-site-header__dropdown, .ally-mobile-nav';
  const root = document.documentElement;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const closeMenus = (except, restoreFocus = false) => {
    document.querySelectorAll(selector).forEach(menu => {
      if (menu !== except && menu.open) {
        menu.open = false;
        if (restoreFocus && menu.contains(document.activeElement)) menu.querySelector('summary')?.focus();
      }
    });
  };

  const setPanelTop = () => {
    const header = document.querySelector('.ally-site-header');
    if (header) root.style.setProperty('--ally-panel-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
  };

  document.addEventListener('click', event => {
    if (event.target.closest('.ally-mobile-nav > summary')) setPanelTop();
    const menu = event.target.closest(selector);
    closeMenus(menu);
    if (menu && event.target.closest('a')) menu.open = false;
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenus(null, true);
  });

  document.addEventListener('focusin', event => {
    if (!event.target.closest('.ally-site-header')) closeMenus();
  });

  // Lock page scroll while the mobile menu is open.
  document.addEventListener('toggle', event => {
    if (!event.target.matches?.('.ally-mobile-nav')) return;
    // Start the panel exactly under the header, whether or not the announcement bar has scrolled away.
    if (event.target.open) setPanelTop();
    root.classList.toggle('ally-nav-open', event.target.open);
  }, true);

  // Desktop: open dropdowns on hover with a short grace period, keep click/keyboard behaviour.
  const bindHover = () => {
    document.querySelectorAll('.ally-site-header__dropdown').forEach(menu => {
      if (menu.dataset.hoverBound) return;
      menu.dataset.hoverBound = 'true';
      let timer;
      menu.addEventListener('mouseenter', () => {
        if (!finePointer.matches) return;
        clearTimeout(timer);
        closeMenus(menu);
        menu.open = true;
      });
      menu.addEventListener('mouseleave', () => {
        if (!finePointer.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => { menu.open = false; }, 160);
      });
      // A click on a hover-opened summary should not immediately close it again.
      menu.querySelector('summary')?.addEventListener('click', event => {
        if (finePointer.matches && menu.open && menu.matches(':hover') && event.detail > 0) event.preventDefault();
      });
    });
  };

  const observeHeader = () => {
    const header = document.querySelector('.shopify-section--ally-site-header');
    if (!header || header.dataset.measured) return;
    header.dataset.measured = 'true';
    new ResizeObserver(entries => {
      const wrapper = entries[0].target;
      const style = root.style;
      style.setProperty('--ally-header-height', `${wrapper.offsetHeight}px`);
      style.setProperty('--header-height', `${wrapper.querySelector('.ally-site-header')?.offsetHeight || 0}px`);
      style.setProperty('--announcement-bar-height', `${wrapper.querySelector('.ally-announcement')?.offsetHeight || 0}px`);
    }).observe(header);
  };

  const init = () => {
    observeHeader();
    bindHover();
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
